"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FlowConfig {
    constructor(initOption) {
        this.$list = initOption.list;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getList(flowKey) {
        return [...this.$list];
    }
    getBuild() {
        return this.$list[0];
    }
    getEnd() {
        return this.$list[this.$list.length - 1];
    }
}
exports.default = FlowConfig;
